export interface ICredentials {
  username: string;
  password: string;
  returnUrl?: string;
}
